"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSortType = void 0;
/**
 * 排序方式(文本，日期，数字，relation)，取值：descending | ascending | manual
 */
var GroupSortType;
(function (GroupSortType) {
    GroupSortType["MANUAL"] = "manual";
    GroupSortType["ASCENDING"] = "ascending";
    GroupSortType["DESCENDING"] = "descending";
})(GroupSortType = exports.GroupSortType || (exports.GroupSortType = {}));
